import { Injectable, inject } from '@angular/core';
import { driver, Driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { TranslateService } from '@ngx-translate/core';
import { profileStore } from '@core/store/profile.store';

@Injectable({ providedIn: 'root' })
export class WelcomeTourService {
  private readonly store = inject(profileStore);
  private readonly translate = inject(TranslateService);
  private driverObj: Driver | null = null;

  start(): void {
    if (!this.store.data.showTour()) return;
    setTimeout(() => this.launch(), 600);
  }

  restart(): void {
    setTimeout(() => this.launch(), 300);
  }

  private t(key: string): string {
    return this.translate.instant(`TOUR.${key}`);
  }

  private dismiss(): void {
    this.store.dismissTour();
  }

  private launch(): void {
    this.driverObj = driver({
      showProgress: true,
      progressText: this.t('PROGRESS'),
      animate: true,
      smoothScroll: true,
      allowClose: true,
      overlayClickBehavior: () => {},
      showButtons: ['next', 'previous', 'close'],
      onCloseClick: () => {
        this.dismiss();
        this.driverObj?.destroy();
      },
      stagePadding: 8,
      stageRadius: 8,
      popoverClass: 'condopal-tour',
      nextBtnText: this.t('BTN_NEXT'),
      prevBtnText: this.t('BTN_PREV'),
      doneBtnText: this.t('BTN_DONE'),
      onDestroyStarted: () => {
        this.dismiss();
        this.driverObj?.destroy();
      },
      steps: [
        {
          popover: {
            title: this.t('WELCOME.TITLE'),
            description: this.t('WELCOME.DESC'),
            showButtons: ['next', 'close'],
            nextBtnText: this.t('WELCOME.BTN_START'),
            onCloseClick: () => {
              this.dismiss();
              this.driverObj?.destroy();
            },
          },
        },
        {
          element: '#tour-sidebar',
          popover: {
            title: this.t('SIDEBAR.TITLE'),
            description: this.t('SIDEBAR.DESC'),
            side: 'right',
            align: 'center',
          },
        },
        {
          element: '#tour-condo-switch',
          popover: {
            title: this.t('CREATE_CONDO.TITLE'),
            description: this.t('CREATE_CONDO.DESC'),
            side: 'right',
            align: 'start',
          },
        },
        {
          element: '#tour-condo-edit-btn',
          popover: {
            title: this.t('EDIT_CONDO.TITLE'),
            description: this.t('EDIT_CONDO.DESC'),
            side: 'right',
            align: 'center',
          },
        },
        {
          element: '#tour-condo-switch',
          popover: {
            title: this.t('CONDO_SWITCH.TITLE'),
            description: this.t('CONDO_SWITCH.DESC'),
            side: 'right',
            align: 'start',
          },
        },
        {
          element: '#tour-menu-finance',
          popover: {
            title: this.t('FINANCE.TITLE'),
            description: this.t('FINANCE.DESC'),
            side: 'right',
            align: 'center',
          },
        },
        {
          element: '#tour-menu-community',
          popover: {
            title: this.t('COMMUNITY.TITLE'),
            description: this.t('COMMUNITY.DESC'),
            side: 'right',
            align: 'center',
          },
        },
        {
          element: '#tour-menu-operations',
          popover: {
            title: this.t('OPERATIONS.TITLE'),
            description: this.t('OPERATIONS.DESC'),
            side: 'right',
            align: 'center',
          },
        },
        {
          element: '#tour-header-user',
          popover: {
            title: this.t('USER_PROFILE.TITLE'),
            description: this.t('USER_PROFILE.DESC'),
            side: 'bottom',
            align: 'end',
          },
        },
        {
          popover: {
            title: this.t('FINISH.TITLE'),
            description: this.t('FINISH.DESC'),
            showButtons: ['previous', 'next', 'close'],
          },
        },
      ],
    });

    this.driverObj.drive();
  }
}
